import { computed, ComputedRef, ref, Ref } from 'vue';
import { defineStore } from 'pinia';
import { RoleChoice, WorkspaceType } from '@/common/interfaces';

export const useWorkspaceStore = defineStore('workspace', () => {
	const name: Ref<string> = ref('');
	const uuid: Ref<string> = ref('');
	const avatar: Ref<string | null> = ref(null);

	const url: ComputedRef<string> = computed(() => {
		return `${location.protocol}//app.medley.so`;
	});

	const setWorkspace = (workspace: WorkspaceType): void => {
		name.value = workspace.name;
		avatar.value = workspace.avatar;
		uuid.value = workspace.uuid;
	}

	return {
		name, url, avatar, uuid,
		setWorkspace
	};
});
